module.exports = __webpack_public_path__ + "static/media/badge1.7ba1913e.png";